import type { DashboardSyncActivity } from "@rbim/shared";
import { CheckCircle2, CircleX, Clock3, MoveRight } from "lucide-react";
import { Link } from "react-router-dom";

export function RecentActivityTable({
  activities,
  loading,
  viewAllPath,
}: {
  activities: DashboardSyncActivity[];
  loading: boolean;
  viewAllPath: string | null;
}) {
  return (
    <section className="dashboard-panel dashboard-recent-activity" aria-labelledby="recent-activity-heading">
      <div className="dashboard-section-heading">
        <h2 id="recent-activity-heading">Recent Activity</h2>
        {viewAllPath ? (
          <Link className="dashboard-view-all" to={viewAllPath}>
            View all activity <MoveRight aria-hidden="true" />
          </Link>
        ) : null}
      </div>

      <div className="responsive-table dashboard-activity-table">
        <table>
          <thead>
            <tr>
              <th>Barangay</th>
              <th>Status</th>
              <th>Records Synced</th>
              <th>Date &amp; Time</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4}><span className="dashboard-table-skeleton">Loading synchronization activity…</span></td></tr>
            ) : activities.length ? activities.map((activity) => (
              <tr key={activity.operationId}>
                <td><strong>{activity.barangayName}</strong></td>
                <td><SyncStatus status={activity.status} /></td>
                <td>{activity.recordCount.toLocaleString()}</td>
                <td><time dateTime={activity.syncedAt}>{formatActivityDateTime(activity.syncedAt)}</time></td>
              </tr>
            )) : (
              <tr><td colSpan={4}>No synchronization activity yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <footer className="dashboard-timezone-note"><Clock3 aria-hidden="true" />All times shown in GMT +8</footer>
    </section>
  );
}

function SyncStatus({ status }: { status: DashboardSyncActivity["status"] }) {
  const completed = status === "COMPLETED";
  const Icon = completed ? CheckCircle2 : CircleX;

  return (
    <span className={completed ? "sync-status completed" : "sync-status failed"}>
      <Icon aria-hidden="true" />
      {completed ? "Completed" : "Failed"}
    </span>
  );
}

function formatActivityDateTime(value: string) {
  return new Intl.DateTimeFormat("en-PH", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: "Asia/Manila",
  }).format(new Date(value));
}
